import { render, staticRenderFns } from "./RadialChart.vue?vue&type=template&id=11b66c57&scoped=true&"
import script from "./RadialChart.vue?vue&type=script&lang=js&"
export * from "./RadialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b66c57",
  null
  
)

export default component.exports